import React from 'react';
import RootPage from '@/components/RootPage/RootPage';
import SectionLoader from '@/components/Loader/SectionLoader';

function RootLoadingPage() {
  return (
    <RootPage>
      <SectionLoader />
    </RootPage>
  );
}

export default RootLoadingPage;
